<template>
  <FormBlock>
    <MaritalStatusSelect v-model="marital.status" />
    <v-expand-transition>
      <AppRow v-if="hasSpouseFields && marital.status == 'married'" class="mt-5">
        <TextField v-model="marital.spouse.name" :rules="[required]" :label="$tt('spouse_name')" />
        <CountrySelect v-model="marital.spouse.countryOfBirth" :label="$tt('spouse_country')" />
      </AppRow>
    </v-expand-transition>
  </FormBlock>
</template>

<script setup lang="ts">
import type { Marital } from '~/types';

const marital = defineModel<Marital>({ required: true });
defineProps<{
  hasSpouseFields?: boolean;
}>();

const { required } = useValidation();
</script>